module.exports = __webpack_public_path__ + "static/img/Def_Bc_OrderCheckout_Right.16d4da4f.png";